export default "__VITE_ASSET__BSCV7BLw__";